import React from 'react';
import { Keyboard, X } from 'lucide-react';
import { keyboardShortcuts } from './pdfConstants';

const PDFKeyboardHelp = ({ showKeyboardHelp, setShowKeyboardHelp }) => {
  if (!showKeyboardHelp) return null;

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-black/70 z-50" onClick={() => setShowKeyboardHelp(false)}>
      <div className="bg-slate-800 rounded-xl p-6 max-w-sm mx-4 shadow-2xl border border-slate-700" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-white flex items-center gap-2">
            <Keyboard className="h-5 w-5 text-teal-400" />
            Atajos de teclado
          </h3>
          <button onClick={() => setShowKeyboardHelp(false)} className="text-slate-400 hover:text-white">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="space-y-3">
          {keyboardShortcuts.map((shortcut, i) => (
            <div key={i} className="flex items-center justify-between">
              <span className="text-slate-400">{shortcut.action}</span>
              <kbd className="px-2 py-1 bg-slate-700 rounded text-sm font-mono text-teal-300">{shortcut.key}</kbd>
            </div>
          ))}
          <div className="flex items-center justify-between">
            <span className="text-slate-400">Modo nocturno</span>
            <kbd className="px-2 py-1 bg-slate-700 rounded text-sm font-mono text-teal-300">N</kbd>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-slate-400">Mostrar ayuda</span>
            <kbd className="px-2 py-1 bg-slate-700 rounded text-sm font-mono text-teal-300">?</kbd>
          </div>
        </div>
        <p className="text-xs text-slate-500 mt-4 text-center">
          Usa los botones + y - para ajustar el zoom
        </p>
      </div>
    </div>
  );
};

export default PDFKeyboardHelp;
